export const ProductCategoryActionsTypes = {
  GET: {
    PRODUCT_CATEGORY_PENDING: "GET_PRODUCT_CATEGORY_PENDING",
    PRODUCT_CATEGORY_SUCCESS: "GET_PRODUCT_CATEGORY_SUCCESS",
    PRODUCT_CATEGORY_ERROR: "GET_PRODUCT_CATEGORY_ERROR",

    PRODUCT_CATEGORY_BY_ID_PENDING: "GET_PRODUCT_CATEGORY_BY_ID_PENDING",
    PRODUCT_CATEGORY_BY_ID_SUCCESS: "GET_PRODUCT_CATEGORY_BY_ID_SUCCESS",
    PRODUCT_CATEGORY_BY_ID_ERROR: "GET_PRODUCT_CATEGORY_BY_ID_ERROR",

    PRODUCTS_BY_CATEGORY_ID_PENDING: "GET_PRODUCTS_BY_CATEGORY_ID_PENDING",
    PRODUCTS_BY_CATEGORY_ID_SUCCESS: "GET_PRODUCTS_BY_CATEGORY_ID_SUCCESS",
    PRODUCTS_BY_CATEGORY_ID_ERROR: "GET_PRODUCTS_BY_CATEGORY_ID_ERROR",
  },
  SET: {
    PRODUCT_CATEGORY_FILTER: "SET_PRODUCT_CATEGORY_FILTER",
  },
};
